<template>
  <div class="teaser-button">
    <div
      v-for="teaser in filteredTeasers"
      :key="teaser.id"
      class="teaser-button__wrapper"
    >
      <div
        class="teaser-button__container"
        @click="toggleOverlay({
          component: 'teaser-modal-section',
          ignoreDismissed: true,
          namespace: teaser.handle,
        })"
      >
        <icon-plus />

        <div
          v-if="teaser.imageMobile?.src || teaser.imageDesktop?.src"
          class="teaser-button__image-container"
        >
          <responsive-image
            :image="isMobile ? teaser.imageMobile : teaser.imageDesktop"
            :sizes="isMobile ? '112px' : '194px'"
            :padding="false"
          />
        </div>

        <div class="teaser-button__content-container">
          <div
            v-if="teaser.title"
            class="teaser-button__title text-heading-l"
            v-text="teaser.title"
          />

          <div
            v-if="teaser.description"
            class="teaser-button__description text-body-s"
            v-html="teaser.description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Teaser button (teaser-button)
 * -----------------------------------------------------------------------------
 * Teaser button.
 *
 * @param {Object} filteredTeasers - filtered Metaobject data.
 */
import { mapActions, mapState } from 'vuex'
import ResponsiveImage from '~global/images/responsive-image'
import IconPlus from '~icons/misc/plus.svg'

export default {
  name: 'TeaserButton',

  components: {
    ResponsiveImage,
    IconPlus,
  },

  props: {
    filteredTeasers: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {

    /**
     * Map Vuex actions.
     */
     ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),
  },
}
</script>

<style lang="scss">
@import './teaser-button';
</style>
